/*** IMPORTS FROM imports-loader ***/
var shim = require("es5-shim/es5-shim");
var sham = require("es5-shim/es5-sham");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createNatsClient = createNatsClient;

var _imMessager = require('im-messager');

var _imMessager2 = _interopRequireDefault(_imMessager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function createNatsClient() {
  var imClientParam = {
    host: window.NAT_SERVERS[0],
    connectType: 'nats',
    maxReconnectTimes: 20,
    reconnectDelay: 5 * 1000,
    heartbeatInterval: 20 * 1000
  };

  if (window.nats && window.nats.close && typeof window.nats.close === 'function') {
    try {
      nats.close();
    } catch (error) {
      // close error
    }
  }
  window.nats = new _imMessager2["default"](imClientParam);

  // 监听nats连接自身状态事件
  this.nats.onClient('ready', function () {
    return console.log('nats client: ready');
  });
  this.nats.onClient('connect', function () {
    return console.log('nats client: connect');
  });
  this.nats.onClient('error', function (err) {
    return console.error('nats client error:', err);
  });
  this.nats.onClient('close', function (close) {
    return console.warn('nats client close:', close);
  });
}



/*****************
 ** WEBPACK FOOTER
 ** ./application/libs/nats.js
 ** module id = 190
 ** module chunks = 1
 **/